export default __webpack_public_path__ + "images/0x1494ca1f11d487c2bbe4543e90080aeba4ba3c2b.png";